import React from 'react';

const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/45t8xwgf_Logo-Fiber_vector-.png';

const Logo = ({ dark = false }) => (
  <div className="flex items-center select-none" aria-label="Fiber Plast">
    <img
      src={LOGO_URL}
      alt="Fiber Plast"
      draggable={false}
      className="h-11 w-auto object-contain"
      style={dark ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
  </div>
);

export default Logo;
